import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Button, Checkbox } from '@zep-us/zus';
import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';
import { getUpsellMessage } from '../utils/quoteUpsell';
import { QuoteUpsellBanner } from './QuoteUpsellBanner';
const PRIVACY_POLICY_URL = 'https://docs.channel.io/zepquiz/ko/articles/%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8-3b3e23ce';

/** 우측 컬럼 — 견적서 발행 예시 + 동의 + 발행 버튼 (Figma right container). */
export function QuotePreviewAside() {
  const {
    control,
    formState: {
      errors,
      isValid,
      isSubmitting
    }
  } = useFormContext<QuizQuoteFormValues>();
  const planType = useWatch<QuizQuoteFormValues, 'plan_type'>({
    name: 'plan_type'
  });
  const term = useWatch<QuizQuoteFormValues, 'term'>({
    name: 'term'
  });
  const userCount = useWatch<QuizQuoteFormValues, 'user_count'>({
    name: 'user_count'
  });
  const upsellMessage = getUpsellMessage({
    planType,
    term,
    userCount
  });
  return <aside className="flex w-full flex-col gap-lg" data-sentry-component="QuotePreviewAside" data-sentry-source-file="QuotePreviewAside.tsx">
      <div className="flex flex-col gap-sm max-tablet-lg:hidden">
        <div className="flex flex-col gap-4xs">
          <h2 className="text-heading-sm-bold text-default">
            견적서 발행 예시
          </h2>
          <p className="text-body-sm-medium text-alternative">
            해당 이미지는 발행 예시이며 실제 견적서가 아닙니다.
          </p>
        </div>
        <img src="/assets/pricing/quote/quote-sample.png" alt="견적서 발행 예시" className="h-[576px] w-full rounded-sm border border-solid border-alternative object-cover shadow-[0px_4px_8px_0px_rgba(28,27,31,0.08)]" />
      </div>

      <Controller control={control} name="consent" render={({
      field
    }) => <label className="flex items-center gap-xs">
            <Checkbox checked={field.value} onCheckedChange={checked => field.onChange(checked === true)} />
            <span className="text-body-md-semibold text-default">
              견적서 발행을 위한{' '}
              <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer" className="text-link" onClick={event => event.stopPropagation()}>
                개인정보 수집 및 이용
              </a>
              에 동의합니다.
            </span>
          </label>} data-sentry-element="Controller" data-sentry-source-file="QuotePreviewAside.tsx" />

      <Button type="submit" variant="contained" intent="strong" size="lg" className="h-12 w-full" disabled={!isValid || isSubmitting} data-sentry-element="Button" data-sentry-source-file="QuotePreviewAside.tsx">
        견적서 발행
      </Button>

      {errors.root?.server?.message ? <p className="text-negative text-body-sm-medium">
          {errors.root.server.message}
        </p> : null}

      {upsellMessage ? <QuoteUpsellBanner key={upsellMessage} message={upsellMessage} /> : null}
    </aside>;
}